import { Document } from 'src/models/document';

import { Callback } from 'src/util/query/models/Callback';

export class DocumentDetailsCallback extends Callback<Document> {
	public constructor(private readonly setDocument: (document: Document | null) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Document): void => {
		this.setDocument(successResponse);
	};
}
